// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* TODO handle this properly with themes */\n\n.ant-btn-variant-solid {\n  background: #00e8d1;\n}", ""]);
// Exports
module.exports = exports;
